<template>
	<div class="user-manager">
		Media library
	</div>
</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import Login from '@/components/Login.vue'

export default
{
	name: 'MediaLibrary',

	components:
	{
		
	}
}

</script>